module.exports = __webpack_public_path__ + "img/cores3.9a2307d5.png";